import React from 'react';
import MainTable from './components/MainTable';

const NoPo = () => {
  return <MainTable />;
};

export default NoPo;
